import React from "react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { methodSteps } from "../../data/content";
export function Method() {
  return <section className="w-full bg-navy px-4 py-16 sm:py-20" aria-label="The 15-minute Decision Lab method" data-id="element-179" data-mp="2ap0uqi8jrsnu">
      <div className="mx-auto max-w-5xl" data-id="element-180" data-mp="26o76tov3uduy">
        <SectionHeading dark title={<>The 15-Minute <em className="text-gold-light" data-id="element-182" data-mp="21ouit0shz0qs">Decision Lab™</em> Method</>} subtitle="One case. One structured reasoning session." data-id="element-181" data-mp="26n5qb4vbkz5u" />

        <ol className="grid gap-3 md:grid-cols-2" data-id="element-183" data-mp="1wo6krv5upjn2">
          {methodSteps.map((step, i) => <li key={step.name} className={`flex items-start gap-4 rounded-2xl bg-navy-soft p-5 ring-1 ring-white/10 ${i === methodSteps.length - 1 ? "md:col-span-2 md:mx-auto md:w-1/2" : ""}`} data-id="element-184" data-mp="1rqoi2mifg0ni" data-mpi={i}>
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gold font-serif text-xl font-bold text-navy-deep" data-id="element-185" data-mp="3i33xf36xtb4f">
                {i + 1}
              </span>
              <div data-id="element-186" data-mp="3chgmnw22ravs">
                <h3 className="text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-187" data-mp="3ci04zdvn01ac">{step.name}</h3>
                <p className="mt-1 text-base leading-relaxed text-white/75" data-id="element-188" data-mp="2yiqm26g1qt2o">{step.question}</p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-10 max-w-2xl text-center text-lg leading-relaxed text-white/85" data-id="element-189" data-mp="32ldkwrb4xe9d">
          The goal isn't to give you an answer for every patient. It's to give you{" "}
          <strong className="text-gold-light" data-id="element-190" data-mp="3vac4lsuwoogs">repeated opportunities to practice</strong> organizing your thinking around educational cases.
        </p>

        <CtaButton label="I want to use the 15-minute method" className="mt-8" data-id="element-191" data-mp="3lhmvh4mtvmom" />
      </div>
    </section>;
}